// @ts-nocheck
import React from "react";

/**
 * The dead end for a DENIED account that is somehow signed in (ACOP-140).
 *
 * Sign-in already refuses Suspended / Rejected / Expired accounts (copilot-api `verifyEmail.ts`), so
 * nobody should reach this. It is the backstop: if one gets in anyway — a status that changed
 * mid-session, say — they get this and nothing else. No side nav, no top bar, no routes, no data
 * calls: Main renders it INSTEAD of the dashboard (David, 2026-10-13: "no menu, no access, dead end").
 *
 * The message is static on purpose. Which denial it was never reaches the client after sign-in
 * (`determineRoles` collapses every denial to the guest tier), and the per-status notes only exist at
 * the verify step, where they are already shown.
 *
 * The only control is Sign out, so the person is not trapped in a session they cannot use.
 */
export const DENIED_MESSAGE = "Your Copilot access is not active. Please contact support.";

function DeniedAccount({ onLogout, logoutBusy }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center vh-100 w-100 bg-body text-center px-3"
      data-testid="denied-account"
      role="alert"
    >
      <i className="fa-solid fa-circle-exclamation fs-1 text-danger mb-3" aria-hidden />
      <h1 className="h4 mb-2">Access denied</h1>
      <p className="text-body-secondary mb-4" style={{ maxWidth: 420 }}>
        {DENIED_MESSAGE}
      </p>
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={onLogout}
        disabled={!!logoutBusy}
        data-testid="denied-account-signout"
      >
        Sign out
      </button>
    </div>
  );
}

export default DeniedAccount;
